import { atom } from "jotai";

export const resumenColaboradorAtom = atom();
export const resumenDocumentoAtom = atom();
export const detallesOnboardingAtom = atom([]);
export const loadingAtom = atom(false);